/* Chefs Evolution – descrierea produsului cu butoane (snippets/ce-descriere.liquid).
   Pe server tot conținutul e la vedere, unul sub altul. Aici:
   - descrierea se împarte după titlurile ei h2 (inclusiv cele ascunse, folosite ca repere) în grupe:
     Despre produs · Ingrediente și alergeni · Informații · Valori nutriționale (+ Întrebări frecvente);
     un titlu necunoscut rămâne în grupa de dinainte, deci nu se pierde nimic;
   - fiecare grupă și fiecare panou din editor (Recenzii, tab HTML, tab Liquid) primește un buton;
   - linkurile către recenzii (#ce-recenzii, insigna Judge.me) deschid panoul Recenzii;
   - window.ceDescriere.arata(element) deschide panoul în care se află un element (scurtăturile de sus).
   Textul descrierii nu se modifică; nodurile doar se mută în grupe. */
(function () {
  if (window.__ceDescriere) return;
  window.__ceDescriere = true;

  var GRUPE = [
    { cheie: 'nutritie', nume: 'Valori nutriționale', re: /nutri|valori energ|valoare energ/ },
    { cheie: 'ingrediente', nume: 'Ingrediente și alergeni', re: /ingredient|alergen|aditiv|poate contine/ },
    { cheie: 'intrebari', nume: 'Întrebări frecvente', re: /intrebari|faq/ },
    { cheie: 'info', nume: 'Informații', re: /informat|depozit|pastrare|valabil|ambalaj|gramaj|mod de serv|reincalz|incalz|preparare|livrare/ },
    { cheie: 'despre', nume: 'Despre produs', re: /despre|descriere|ocazi|de ce |povest|gust|ideal|recomand|servire/ }
  ];
  var ICOANE = {
    despre: '<path d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm0 4.2a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4zM13.2 17h-2.4v-6h2.4z" fill="currentColor"/>',
    ingrediente: '<path d="M17 3c-6 0-11 3.6-11 10 0 1.4.3 2.7.9 3.8L4 19.6 5.4 21l2.8-2.8c1.1.6 2.4.8 3.8.8 6.4 0 9-6 9-13V3h-4zm-5 14c-.8 0-1.6-.1-2.3-.4l5-5-1.4-1.4-5 5c-.2-.7-.3-1.4-.3-2.2 0-4.7 3.7-7.5 8.6-8H19v.9C19 12.7 16.6 17 12 17z" fill="currentColor"/>',
    info: '<path d="M7 2h10v2h3v18H4V4h3V2zm2 2v2h6V4H9zM6 6v14h12V6h-1v2H7V6H6zm2 5h8v2H8v-2zm0 4h6v2H8v-2z" fill="currentColor"/>',
    nutritie: '<path d="M4 20h16v2H4v-2zM5 10h3v8H5v-8zm5.5-6h3v14h-3V4zM16 13h3v5h-3v-5z" fill="currentColor"/>',
    intrebari: '<path d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zm.1 14.6a1.2 1.2 0 1 1 0-2.4 1.2 1.2 0 0 1 0 2.4zm1.6-5.9c-.7.5-.9.8-.9 1.6v.3h-2.2v-.5c0-1.3.4-2 1.4-2.7.8-.6 1.1-.9 1.1-1.5s-.5-1.1-1.3-1.1c-.9 0-1.4.5-1.5 1.4H8.1c.1-2.1 1.6-3.4 3.8-3.4 2.1 0 3.6 1.2 3.6 3 0 1.2-.6 2-1.8 2.9z" fill="currentColor"/>',
    recenzii: '<path d="M12 2.8l2.8 5.8 6.3.9-4.6 4.4 1.1 6.3L12 17.2l-5.6 3 1.1-6.3L2.9 9.5l6.3-.9z" fill="currentColor"/>',
    altul: '<path d="M5 4h14v2H5V4zm0 5h14v2H5V9zm0 5h14v2H5v-2zm0 5h9v2H5v-2z" fill="currentColor"/>'
  };

  function curat(t) {
    return (t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim().toLowerCase();
  }
  function grupaPentru(text) {
    var t = curat(text);
    if (!t) return null;
    for (var i = 0; i < GRUPE.length; i++) if (GRUPE[i].re.test(t)) return GRUPE[i];
    return null;
  }
  function esteAscuns(el) {
    var st = (el.getAttribute('style') || '').replace(/\s/g, '').toLowerCase();
    return st.indexOf('display:none') > -1;
  }

  // împarte descrierea; întoarce lista grupelor create (sau [] dacă nu are ce împărți)
  function imparteDescrierea(panou) {
    var h2 = panou.querySelector('h2');
    if (!h2) return [];
    var radacina = h2.parentElement;
    var noduri = Array.prototype.slice.call(radacina.childNodes);
    var grupe = [], dupaCheie = {}, curenta = null;
    function grupa(def) {
      if (dupaCheie[def.cheie]) return dupaCheie[def.cheie];
      var g = { def: def, noduri: [] };
      dupaCheie[def.cheie] = g;
      grupe.push(g);
      return g;
    }
    noduri.forEach(function (n) {
      if (n.nodeType === 1 && n.tagName === 'H2') {
        var def = grupaPentru(n.textContent);
        if (def) curenta = grupa(def);
      }
      if (!curenta) curenta = grupa(GRUPE[GRUPE.length - 1]);
      curenta.noduri.push(n);
    });
    if (grupe.length < 2) return [];
    grupe.forEach(function (g) {
      var div = document.createElement('div');
      div.className = 'ce-desc__grupa';
      div.setAttribute('data-ce-desc-grupa', g.def.cheie);
      g.noduri.forEach(function (n) { div.appendChild(n); });
      radacina.appendChild(div);
      g.el = div;
    });
    return grupe;
  }

  function porneste() {
    var cutie = document.querySelector('[data-ce-desc]');
    if (!cutie) return;
    var nav = cutie.querySelector('[data-ce-desc-nav]');
    var panouri = Array.prototype.slice.call(cutie.querySelectorAll('[data-ce-desc-panou]'));
    if (!nav || !panouri.length) return;

    var file = []; // { id, nume, icoana, el (ce se arată), panou, extra }
    var areNutritie = false;
    panouri.forEach(function (p) {
      var tip = p.getAttribute('data-ce-desc-tip');
      if (tip === 'descriere') {
        var grupe = imparteDescrierea(p);
        if (grupe.length) {
          grupe.forEach(function (g) {
            if (g.def.cheie === 'nutritie') areNutritie = true;
            file.push({ id: 'ce-desc-' + g.def.cheie, nume: g.def.nume, icoana: g.def.cheie, el: g.el, panou: p });
          });
          return;
        }
        file.push({ id: p.id, nume: p.getAttribute('data-titlu') || 'Descriere', icoana: 'despre', el: p, panou: p });
        return;
      }
      if (tip === 'recenzii') {
        file.push({ id: p.id, nume: p.getAttribute('data-titlu') || 'Recenzii', icoana: 'recenzii', el: p, panou: p,
          nota: p.getAttribute('data-nota'), numar: p.getAttribute('data-numar') });
        return;
      }
      var titlu = p.getAttribute('data-titlu') || '';
      var def = grupaPentru(titlu);
      file.push({ id: p.id, nume: titlu, icoana: def ? def.cheie : 'altul', el: p, panou: p, nutritie: def && def.cheie === 'nutritie' });
    });
    // tabul „Valori nutriționale” din editor e de prisos când descrierea are deja declarația nutrițională
    file = file.filter(function (f) {
      if (f.nutritie && areNutritie) { f.panou.hidden = true; return false; }
      return true;
    });
    if (file.length < 2 && !file.some(function (f) { return f.icoana === 'recenzii'; })) {
      cutie.classList.add('is-simplu');
      return;
    }

    nav.innerHTML = file.map(function (f, i) {
      var extra = '';
      if (f.nota) extra = '<span class="ce-desc__nota">★ ' + f.nota + (f.numar ? ' · ' + f.numar : '') + '</span>';
      return '<button type="button" role="tab" class="ce-desc__buton" id="ce-desc-buton-' + i + '" aria-controls="' + f.id + '" aria-selected="false" tabindex="-1" data-ce-desc-la="' + i + '">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true">' + (ICOANE[f.icoana] || ICOANE.altul) + '</svg><span>' + f.nume.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }) + '</span>' + extra + '</button>';
    }).join('');
    file.forEach(function (f, i) {
      if (f.el !== f.panou || !f.el.id) f.el.id = f.id;
      f.el.setAttribute('role', 'tabpanel');
      f.el.setAttribute('aria-labelledby', 'ce-desc-buton-' + i);
      f.el.setAttribute('tabindex', '-1');
    });
    var butoane = Array.prototype.slice.call(nav.querySelectorAll('[data-ce-desc-la]'));
    nav.hidden = false;
    cutie.classList.add('is-gata');

    var activ = -1;
    function arataNr(i, focus) {
      if (i < 0 || i >= file.length) return;
      activ = i;
      var ales = file[i];
      file.forEach(function (f, j) {
        var da = j === i;
        f.el.hidden = !da;
        // panoul descrierii rămâne vizibil cât timp una dintre grupele lui e aleasă
        if (f.el !== f.panou) f.panou.hidden = ales.panou !== f.panou;
        butoane[j].setAttribute('aria-selected', da ? 'true' : 'false');
        butoane[j].tabIndex = da ? 0 : -1;
        butoane[j].classList.toggle('is-activ', da);
      });
      ales.panou.hidden = false;
      var b = butoane[i];
      if (nav.scrollWidth > nav.clientWidth) nav.scrollTo({ left: Math.max(0, b.offsetLeft - 16), behavior: 'smooth' });
      if (focus) b.focus();
      // aplicațiile de recenzii își recalculează înălțimea când panoul devine vizibil
      try { window.dispatchEvent(new Event('resize')); } catch (e) {}
    }
    function indexPentru(el) {
      for (var i = 0; i < file.length; i++) if (file[i].el === el || file[i].el.contains(el)) return i;
      return -1;
    }
    function duLa(el) {
      var sus = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--ce-sus'), 10) || 0;
      var y = el.getBoundingClientRect().top + window.pageYOffset - sus - 20;
      window.scrollTo({ top: Math.max(0, y), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }

    nav.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ce-desc-la]');
      if (b) arataNr(Number(b.getAttribute('data-ce-desc-la')));
    });
    nav.addEventListener('keydown', function (e) {
      var k = e.key, i = activ;
      if (k === 'ArrowRight') i = (activ + 1) % file.length;
      else if (k === 'ArrowLeft') i = (activ - 1 + file.length) % file.length;
      else if (k === 'Home') i = 0;
      else if (k === 'End') i = file.length - 1;
      else return;
      e.preventDefault();
      arataNr(i, true);
    });

    var recenzii = -1;
    file.forEach(function (f, i) { if (f.icoana === 'recenzii') recenzii = i; });
    function deschideRecenzii() {
      if (recenzii < 0) return false;
      arataNr(recenzii);
      setTimeout(function () { duLa(cutie); }, 60);
      return true;
    }
    // insigna cu stele de lângă preț, linkurile #ce-recenzii / #judgeme_product_reviews
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="#ce-recenzii"],a[href*="#judgeme_product_reviews"],a[href*="#t4s-tab-review"],.jdgm-prev-badge,.t4s-product__price-review .jdgm-widget');
      if (!a || cutie.contains(a)) return;
      if (deschideRecenzii()) e.preventDefault();
    }, true);

    window.ceDescriere = {
      arata: function (el) { var i = indexPentru(el); if (i > -1) arataNr(i); return i > -1; },
      deschideRecenzii: deschideRecenzii
    };

    var hash = (location.hash || '').slice(1);
    var dinHash = -1;
    if (hash) {
      if (/^(ce-recenzii|judgeme_product_reviews|t4s-tab-review)/.test(hash)) dinHash = recenzii;
      else { var t = document.getElementById(hash); if (t) dinHash = indexPentru(t); }
    }
    arataNr(dinHash > -1 ? dinHash : 0);
    if (dinHash > -1) setTimeout(function () { duLa(cutie); }, 300);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', porneste); else porneste();
})();
